import React, { memo, useState } from 'react'
import { useAuthStore } from '../../lib/zustand'

import { ReactComponent as IconSignout } from '../../assets/svg/log-out.svg'
import { getCurrentUser } from '../../utils/helper/currentUser'
import { useNavigate } from 'react-router-dom'
import SafeImage from '../atoms/SafeImage'

const Topbar = () => {
  const { setLogout } = useAuthStore()
  const [isPopupOpen, setPopupOpen] = useState(false)
  const currentUser = getCurrentUser()
  const nativate = useNavigate()

  const handlePopupToggle = () => {
    setPopupOpen((old) => !old)
  }

  const handleLogout = () => {
    setLogout()
  }

  return (
    <section
      className="fixed top-0 z-20 flex h-auto w-screen items-center justify-between bg-white px-[40px] py-[10px]"
      style={{ boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.06)' }}
    >
      <h1 className="bg-gradient-to-r from-[#B799FF] to-[#AEE2FF] bg-clip-text text-xl font-bold uppercase leading-7 tracking-wide text-transparent">
        Logbook Tegalsari <span className="text-[10px]">v4.0</span>
      </h1>
      <div className="relative">
        <div
          className="relative h-8 w-8 overflow-hidden rounded-full bg-slate-200"
          onClick={handlePopupToggle}
        >
          {currentUser?.avatar !== '' ? (
            <SafeImage
              src={`${currentUser?.avatar}`}
              className="h-full w-full object-cover"
              fallbackSrc="/img/avatar-placeholder.svg"
            />
          ) : (
            <SafeImage
              src="/img/default_pp.webp"
              className="h-full w-full object-cover"
              fallbackSrc="/img/avatar-placeholder.svg"
            />
          )}
        </div>
        {isPopupOpen && (
          <div className="absolute -bottom-[100px] -right-2 z-30 flex w-[150px] flex-col gap-2 rounded-lg bg-white shadow-md">
            <div
              className="flex cursor-pointer items-center gap-2 px-4 py-2 text-[#B799FF] hover:bg-slate-400 hover:bg-opacity-10 hover:underline"
              onClick={() => nativate('/update-profile')}
            >
              Update Profile
            </div>
            <div
              className="flex cursor-pointer items-center gap-2 px-4 py-2 text-[#B799FF] hover:bg-slate-400 hover:bg-opacity-10 hover:underline"
              onClick={handleLogout}
            >
              Logout <IconSignout />
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default memo(Topbar)
